import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import { useUiStateStore } from '../uiState/UiStateStore'
import { SimpleModal } from '../../ui-components/modals/SimpleModal'
import { Translate } from 'common'
import { DiscardAndStartNewOrderActions } from '../../ui-components/util/Interfaces'

export const DiscardAndStartNewOrder = observer((): ReactElement => {
  const uiStore = useUiStateStore()
  const { promise } = uiStore.discardAndStartNewOrderModalParams || {}

  return (
    <SimpleModal
      title="startNewOrder"
      primaryActionText="discardAndStartNew"
      secondaryActionText="cancel"
      onPrimaryAction={() => {
        promise?.resolve(DiscardAndStartNewOrderActions.START_NEW)
      }}
      onSecondaryAction={() =>
        promise?.resolve(DiscardAndStartNewOrderActions.CANCEL)
      }
      onCancel={() => promise?.resolve(DiscardAndStartNewOrderActions.CANCEL)}
      disablePrimaryButton={false}
      show={uiStore.showDiscardAndStartNewOrderModal}
    >
      {Translate('discardAndStartNewCartMessage')}
    </SimpleModal>
  )
})
